import script from "./LabHub.vue?vue&type=script&setup=true&lang=js"
export * from "./LabHub.vue?vue&type=script&setup=true&lang=js"

import "./LabHub.vue?vue&type=style&index=0&id=7ad64c20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad64c20"]])

export default __exports__